import styled from 'styled-components';
import { BasketFeesDetailsStyled } from '../BasketFeesDetailsStyled';
import { rem } from 'polished';

export const BasketFeesDetailsOV = styled(BasketFeesDetailsStyled)`
    .title {
        font-size: ${rem(20)};
    }
    
    .carteGriseInput {
        .postalCode {
            &_warning {
                .icon-wrapper {
                    svg {
                        path {
                            fill: ${({ theme }) => theme.colors.pureWhite};
                        }
                    }    
                }
            }
            
            &_input {
                button {
                    font-size: ${({ theme }) => theme.fontSizes.h6};
                    
                    &:hover {
                        background: ${({ theme }) => theme.colors.primary};
                        border-color: ${({ theme }) => theme.colors.primaryHover};
                        color: ${({ theme }) => theme.colors.primaryHover};
                    }
                }
            }
        }
    }
`;
